import { FC, ReactNode } from 'react';

import styled from '@emotion/styled';
import { GetExamTypeName } from 'core/const/ExamType';
import { ComponentDetail } from 'store/basket/basketAPI';
import { formatDate } from 'core';

import { Card } from '@britishcouncil/react-solas-ors3';

export const ExamCard: FC<{
  onlyMainParams?: boolean;
  exam: {
    syllabusName: string;
    name: string;
    componentDetails: ComponentDetail[];
    qualificationLevel: string;
    code: string;
    fee: number;
    currency: string;
    awardingBody?: string;
    district?: string;
    isCarryForward: boolean;
    retakeSelected?: boolean;
  };
}> = ({ exam, onlyMainParams = false, children }) => {
  return (
    <Card>
      <ExamCardHeader>{`${exam.syllabusName} - ${exam.name}`}</ExamCardHeader>
      <ExamCardValuesList>
        <tbody>
          <ExamCardParameter label={'Level:'} value={exam.qualificationLevel} />
          <ExamCardParameter label={'Code:'} value={exam.code} />
          <ExamCardParameter
            label={'Type:'}
            value={GetExamTypeName(exam.retakeSelected === true, exam.isCarryForward)}
          />
          {!onlyMainParams && (
            <>
              {exam.awardingBody && <ExamCardParameter label={'Board:'} value={exam.awardingBody} />}
              {exam.district && <ExamCardParameter label={'Location:'} value={exam.district} />}
            </>
          )}
        </tbody>
      </ExamCardValuesList>
      {!onlyMainParams && (
        <ComponentsList>
          {exam.componentDetails?.map((x, i) => {
            let examDateString = '';
            if (x.examDate) {
              examDateString = `- ${formatDate(x.examDate)}`;
            }

            let sessionTimeString = '';
            if (x.sessionTime) {
              sessionTimeString = `- ${x.sessionTime}`;
            }

            return (
              <ComponentItem key={i}>
                <span className="component-name">{x.name} XX</span>
                <span className="component-date">{examDateString}</span>
                <span className="component-time">{sessionTimeString}</span>
              </ComponentItem>
            );
          })}
        </ComponentsList>
      )}

      <tbody>
        <ExamCardPrice label={'Price:'} value={exam.fee.toFixed(2) + ' ' + exam.currency} />
      </tbody>
      {children}
    </Card>
  );
};

export const ExamCardParameter: FC<{ label: string; value: ReactNode }> = ({ label, value }) => (
  <tr>
    <StyledCell>{label}</StyledCell>
    <StyledCell>
      <StyledValue>{value}</StyledValue>
    </StyledCell>
  </tr>
);

export const ExamCardPrice: FC<{ label: string; value: string | number | undefined }> = ({ label, value }) => (
  <tr>
    <StyledCell>{label}</StyledCell>
    <StyledCell>
      <StyledPriceValue>{value}</StyledPriceValue>
    </StyledCell>
  </tr>
);

export const ExamCardHeader = styled('h3')`
  margin-bottom: 8px;
`;

export const ExamCardValuesList = styled('table')`
  background-color: transparent;
  font-size: 1em;
  margin-bottom: 0;
  margin-top: 20px;
`;

const StyledCell = styled.td`
  padding: 2px 0;
`;

const StyledValue = styled('strong')`
  margin-left: 1em;
`;

const StyledPriceValue = styled('strong')`
  margin-left: 1em;
  font-size: 1.2em;
`;

const ComponentsList = styled.ul`
  list-style: none;
  margin: 20px 0 20px 0;
  font-size: 1em;
  font-family: BCSans, Arial, 'Helvetica Neue', Helvetica, sans-serif;
`;

const ComponentItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid #e0e0e0;

  & span {
    margin: 0;
    padding: 0;
  }

  .component-name {
    width: 60%;
  }

  .component-date,
  .component-time {
    width: 20%;
    text-align: right;
  }

  &:last-of-type {
    border-bottom: none;
  }
`;
